import type { FC } from "react";

import { CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

import type { CardsElementProps } from "../types";

export const CustomCardHeader: FC<CardsElementProps> = ({
  children,
  classes,
}) => {
  return (
    <CardHeader
      className={cn(
        "flex flex-col gap-3 px-4 md:px-[30px] py-0 mb-4 md:mb-8",
        classes
      )}
    >
      {children}
    </CardHeader>
  );
};
